import { UserIdentityVerificationState } from '@pages/user-identity-verification/store/states/user-identity-verification.state';

export const userIdentityVerificationStates = [UserIdentityVerificationState];
